import { AnalysisService } from "@/services/analysis/analysis.service";

export const useAnalysisVocs = (
  analysisId: string | undefined,
  categoryPath: string | undefined,
) => {
  const { vocs, error, isLoading } = AnalysisService.getAnalysisVocs(
    analysisId,
    categoryPath,
  );

  return {
    vocs,
    error,
    isLoading,
  };
};
